module.exports = __webpack_public_path__ + "static/media/pt.9b8790d5.svg";